/** Vibes mobile-web club profile palette */
export const vibesColors = {
  primary_pink: "#FA69B9",
  white: "#fff",
  fontgary: "#424148",
  violate: "#8D34FF",
  primary_blue: "#0A0735",
  black: "#000000",
  disableGray: "#8B8A91",
  lightGray: "#E0E0E0",
  green: "#66D460",
  red: "rgba(223, 28, 65, 1)",
  textColor: "#868C98",
  gradient_dark_purple: "#090014",
  gradient_light_purple: "#14002C",
  cardBackground: "rgba(18, 1, 40, 1)",
  categoryBackground: "rgba(141, 52, 255, 0.2)",
  BtnBackground: "rgba(141, 52, 255, 1)",
  borderColor: "#E5E5E5",
  lightBackground: "#F8F9FA",
};
